import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
const MONO = "font-mono text-xs";
export const FormulaBar = ({
  address,
  value,
}: {
  address: string | null;
  value: string | undefined;
}) => (
  <Stack
    gap={0}
    align="stretch"
    direction="row"
    className="flex min-h-[30px] shrink-0 items-stretch border-b border-line bg-surface-sunken"
  >
    <span className="flex min-w-[52px] items-center justify-center border-r border-line bg-surface-sunken px-2 text-xs font-semibold text-subtle">
      {address ?? "Cell"}
    </span>
    <span
      className={cn(
        "flex max-h-20 min-w-0 flex-1 items-center overflow-auto px-2.5 py-1 wrap-break-word whitespace-pre-wrap",
        value ? MONO : "text-xs text-subtle italic",
      )}
    >
      {value || "Select a cell to see its value"}
    </span>
  </Stack>
);
